import { createFileRoute } from "@tanstack/react-router";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { z } from "zod";
import { ExterneOfferteWizard } from "@/components/site/ExterneOfferteWizard";

export const Route = createFileRoute("/offerte-aanvragen")({
  validateSearch: zodValidator(z.object({ product: z.string().optional(), stap: fallback(z.number(), 0).default(0) })),
  head: () => ({ meta: [
    { title: "Offerte aanvragen voor jouw project | Elvion Group Nederland" },
    { name: "description", content: "Vraag een offerte aan voor elektrotechniek, groepenkasten, laadpalen of beveiliging. Vertel over jouw project en ontvang passende offertes." },
    { property: "og:title", content: "Offerte aanvragen | Elvion Group Nederland" },
    { property: "og:description", content: "Vraag in enkele stappen passende offertes aan voor jouw installatieproject." },
    { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary_large_image" },
  ], links: [{ rel: "canonical", href: "https://elvion-group.nl/offerte-aanvragen" }] }),
  component: OfferteAanvragen,
});
function OfferteAanvragen() {
  const { product, stap } = Route.useSearch();
  const safeStep = Math.max(0, Math.min(9, Math.floor(Number.isFinite(stap) ? stap : 0)));
  return <ExterneOfferteWizard key={product || "algemeen"} slug={product} stap={safeStep} />;
}